export const STEPS_PROJECT_FORM = Object.freeze({
  ABOUT_PROJECT: 'About Project',
  ARTIFACTS: 'Artifacts',
});
